import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import cx from "classnames";
import offer from "../../assets/utils/images/donot_miss.png";
import AppSidebar from '../../Layout/AppSidebar';
import AppHeader from '../../Layout/AppHeader/SplitHeader';
import Loading from '../../Common/Loading';
import { getHeaderNotification, checkIsPageNotFound, checkIsAgencyView, getLicenseErrorStatus, processValidLicense, customConfirmBox } from '../../Common/Appcommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import noAccessImag from '../../assets/utils/images/403.jpg';
import { useAppContext } from '../../Context/AppContext';
import { Button, Modal, ModalBody } from 'reactstrap';

const SplitCommon = (props) => {
    const useThemeFunc = useAppContext();
    const { showPopupNoti, showHeaderNoti, headerNotiContent } = useThemeFunc;
    const [notification, setNotification] = useState({ show: false })
    let { sideBarContent, mainContent, sideBarTitleContent, mainTitleContent, title, sideBarLoader, mainLoader, mobileViewNeedLeftMenu = false,titleKey='' } = props;
    const [isRedirectNeeded, setIsRedirectNeeded] = useState(false);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal); 

    if (title !== undefined && title !== "") {
        document.title = title;
    }

    useEffect(() => {
        const fetchPageDetails = async () => {
            if(titleKey !== "" && titleKey !== undefined && titleKey !== null){
                let isPageNotFound = await checkIsPageNotFound(titleKey);
                if (isPageNotFound) {
                    setIsRedirectNeeded(isPageNotFound);
                    return;
                }
            }
        }
        fetchPageDetails();
        async function getNotification() {
            let isAgencyView = checkIsAgencyView();
            let header_noti = getLicenseErrorStatus("header_noti");
            if(!isAgencyView && header_noti){
                let headernotification = await getHeaderNotification(showHeaderNoti, headerNotiContent);
                setNotification(headernotification);
            }
        }
        getNotification();
    }, []);

    useEffect(() => {
        processValidLicense(useThemeFunc, toggle);
    }, [showPopupNoti])

    const oncloseAction = () => {
        setNotification(false);
    }

/*     const customConfirmBox = () => {
        const redirectPage = () => {
            window.location.hash = "#/subscription";
            toggle();
        }
        return (
            <div className=''>
              <Modal isOpen={modal} className='agency-trial-end-popup' centered>
                <ModalBody>
                    <img src={offer} width={200} height={150} className='mb-3'></img>
                    <h3>Your FREE Trial Has Ended!</h3>
                    <p>Unlock Voicemetrics for a one-time price – No recurring fees, ever!</p>
                    <Button className='buy-btn' onClick={e => redirectPage()}>
                        Buy Lifetime Deal
                    </Button>
                    <p className="mt-2">🔥 Claim your discount before it's gone! 🔥</p>
                </ModalBody>
              </Modal>
            </div>
          );
    } */

    return (
        <Fragment>
            <div className={cx('header-notification', {
                'hide': !notification.show
            })}>
                <div className={'header-notification-body'}>
                    <>
                        {notification.icon && <FontAwesomeIcon icon={faInfoCircle} />}
                        {notification.text}
                    </>
                </div>
                <button type="button" className="btn-close" aria-label="Close" onClick={(e) => { oncloseAction(e) }} ></button>
            </div>
            {isRedirectNeeded ? (
                <>
                 <div className='no-records-container'>
                 <div className='d-grid align-center'>
                     <img src={noAccessImag} alt={"Forbidden"}/>
                 </div>
             </div>
             </>): ( <>
            <AppHeader
                sideBarTitleContent={sideBarTitleContent}
                mainTitleContent={mainTitleContent}
                headerNotifyShow={notification.show}
                mobileViewNeedLeftMenu = {mobileViewNeedLeftMenu}
            />
            <div className={cx('app-main', {
                'header-notify-active': notification.show
            })}>
                <AppSidebar useThemeFunc={useThemeFunc}/>
                <div className="app-main__outer">
                    <div className="app-main__inner split-app-outer">
                        <div>
                            <div className={cx("app-inner-layout chat-layout", {
                                "open-mobile-menu": false,
                            })}>
                                <div className="app-inner-layout__wrapper">
                                    <div className='app-inner-layout__content'>
                                        <Loading className={`w-100`} showLoader={mainLoader} mainContent={
                                            <div className="w-100">
                                                {mainContent}
                                            </div>
                                        } />
                                    </div>
                                    <div className="app-inner-layout__sidebar">
                                        <div className={`w-100 ${sideBarLoader ? 'hvh-100' : ''}`}>
                                            <Loading showLoader={sideBarLoader} mainContent={sideBarContent} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        customConfirmBox(toggle, modal)
                    }
                </div>
            </div>
            </>)}
        </Fragment>
    )
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SplitCommon);
